import {
  customerServiceMockStateKey,
  documentServiceMockStateKey,
  mockOutcomeKey,
  mocksEnabledKey,
  slowModeKey,
} from "src/mocks/settings/keys";


const DEFAULT_MOCK_OUTCOME = "success";

export const getSettingsFromStorage = () => {
  const mocksEnabled = localStorage.getItem(mocksEnabledKey);
  const mocksOutcome = localStorage.getItem(mockOutcomeKey) ?? DEFAULT_MOCK_OUTCOME;
  const customerServiceMockEnabled = localStorage.getItem(customerServiceMockStateKey);
  const slowMode = localStorage.getItem(slowModeKey);
  const documentServiceMockEnabled = localStorage.getItem(documentServiceMockStateKey);
  return {
    mocksEnabled: mocksEnabled === "true",
    mocksOutcome,
    customerServiceMockEnabled: customerServiceMockEnabled === "true",
    slowMode: slowMode === "true",
    documentServiceMockEnabled: documentServiceMockEnabled === "true",
  };
};

const setSettingInStorage = (key: string, value: boolean | string) => {
  localStorage.setItem(key, typeof value === "boolean" ? value.toString() : value);
};

export const setMockOutcomeToStorage = (value: string) => {
  setSettingInStorage(mockOutcomeKey, value);
};

export const setMocksEnabledToStorage = (value: boolean) => {
  setSettingInStorage(mocksEnabledKey, value);
};

export const setCustomerServiceMockEnabledToStorage = (value: boolean) => {
  setSettingInStorage(customerServiceMockStateKey, value);
};

export const setSlowModeToStorage = (value: boolean) => {
  setSettingInStorage(slowModeKey, value);
};

export const setDocumentServiceMockEnabledToStorage = (value: boolean) => {
  setSettingInStorage(documentServiceMockStateKey, value);
};
